import { render, staticRenderFns } from "./moneyPassRecord.vue?vue&type=template&id=4edc038e&scoped=true&"
import script from "./moneyPassRecord.vue?vue&type=script&lang=js&"
export * from "./moneyPassRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edc038e",
  null
  
)

export default component.exports